import { IncidentsStoreState } from '@innovyze/stylovyze';
import { moduleNamespace } from '@Store/config.store';
import { PopStoreState } from '@Reducers/popup.reducer';

export interface StoreState {
	incidents?: IncidentsStoreState;
	stylovyzeIncidents?: IncidentsStoreState;
	popup?: PopStoreState;
}

export interface NamespacedStoreState {
	[moduleNamespace]: StoreState;
	stylovyzeIncidents: IncidentsStoreState;
}

// Was originally '= {}' (generated by old plop) which is eslint bad now - so remove never when finally/if add properties
export type PartialStoreState = Record<string, never>;

export interface NamespacedPartialStoreState {
	[moduleNamespace]: PartialStoreState;
}
